import { cn } from '@/lib/utils';

export interface UsageRecord {
    id: string;
    date: string; // ISO string for filtering, or Date object
    displayDate: string; // Formatted
    type: string;
    /** Tipo de operación (ej. "Envío WhatsApp", "Push notification") */
    model: string;
    /** Volumen (ej. "234 mensajes", "1.2k usuarios") */
    tokens: string;
    /** Costo en créditos o "Incluido" si entró en el plan */
    cost: string;
}

interface UsageTableProps {
    data: UsageRecord[];
    isLoading?: boolean;
}

export const UsageTable = ({ data, isLoading = false }: UsageTableProps) => {
    if (isLoading) {
        return (
            <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm p-8 flex justify-center items-center min-h-[300px]">
                <div className="flex flex-col items-center gap-3 animate-pulse">
                    <div className="h-8 w-8 rounded-full border-2 border-gray-200 border-t-gray-400 animate-spin" />
                    <span className="text-sm text-gray-400 font-medium">Actualizando datos...</span>
                </div>
            </div>
        );
    }

    if (data.length === 0) {
        return (
            <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm p-12 flex flex-col justify-center items-center text-center min-h-[300px]">
                <div className="bg-gray-50 p-3 rounded-full mb-3">
                    <span className="text-2xl">📊</span>
                </div>
                <h3 className="text-gray-900 font-medium mb-1">Sin actividad en este período</h3>
                <p className="text-gray-500 text-sm">Probá seleccionando otro rango de fechas.</p>
            </div>
        );
    }

    return (
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm animate-fade-in">
            <div className="overflow-x-auto">
                <table className="w-full text-left text-sm">
                    <thead>
                        <tr className="bg-gray-50 border-b border-gray-100">
                            <th className="py-3 px-6 font-medium text-gray-500 w-1/4">Fecha</th>
                            <th className="py-3 px-6 font-medium text-gray-500">Plan</th>
                            <th className="py-3 px-6 font-medium text-gray-500">Operación</th>
                            <th className="py-3 px-6 font-medium text-gray-500 text-right">Volumen</th>
                            <th className="py-3 px-6 font-medium text-gray-500 text-right">Costo</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {data.map((row) => (
                            <tr key={row.id} className="hover:bg-gray-50/50 transition-colors">
                                <td className="py-3 px-6 text-gray-600">{row.displayDate}</td>
                                <td className="py-3 px-6 text-gray-600">
                                    <span className="bg-gray-100 px-2 py-0.5 rounded text-xs font-medium text-gray-600 border border-gray-200">
                                        {row.type}
                                    </span>
                                </td>
                                <td className="py-3 px-6 text-gray-700 text-xs">{row.model}</td>
                                <td className="py-3 px-6 text-gray-900 font-medium text-right">{row.tokens}</td>
                                <td className="py-3 px-6 text-gray-600 text-right">
                                    {row.cost === 'Incluido' ? (
                                        <span className="text-emerald-600 font-medium text-xs bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-100">Incluido</span>
                                    ) : (
                                        <span className="text-gray-900">{row.cost}</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
